import { z } from 'zod';

export const danceCodes = [
	'wcs', 'zouk', 'salsa', 'bachata', 'kizomba', 'balboa', 'hustle', 'dirtyfox',
	'lindyhop', 'tango', 'discofox', 'modernjive', 'shag', 'ceroc', 'country',
] as const;

export const dances: {
	[code in typeof danceCodes[number]]: { name: string }
} = {
	'wcs': { name: 'West Coast Swing' },
	'zouk': { name: 'Zouk' },
	'salsa': { name: 'Salsa' },
	'bachata': { name: 'Bachata' },
	'kizomba': { name: 'Kizomba' },
	'balboa': { name: 'Balboa' },
	'hustle': { name: 'Hustle' },
	'dirtyfox': { name: 'Dirty Fox' },
	'lindyhop': { name: 'Lindy Hop' },
	'tango': { name: 'Tango' },
	'discofox': { name: 'Discofox' },
	'modernjive': { name: 'Modern Jive' },
	'shag': { name: 'Shag' },
	'ceroc': { name: 'Ceroc' },
	'country': { name: 'Country' },
} as const;

export const danceSchema = /* @__PURE__ */ z.enum(danceCodes);

export type Dance = typeof danceCodes[number];
